<template>
  <div>
    <a-modal v-model="visible" title="Edit vehicle" onOk="handleOk" :width="720">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Update</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Vehicle No.">
          <a-input placeholder="Vehicle No."
            v-decorator="['vehicle_no', { rules: [{ required: true, message: 'Please input vehicle no.!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
        </a-form-item>
        <a-form-item label="Registration No.">
          <a-input placeholder="Registration No."
            v-decorator="['registration_no', { rules: [{ required: true, message: 'Please input registration no.!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
        </a-form-item>

        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Select Driver" class="mb-2">
              <a-select
                show-search
                size="default"
                v-decorator="['staff_id',{
                  rules: [{
                    required: true,
                    message: 'Please select a driver',
                  }],
                }]"
                placeholder="Search driver."
                style="width: 100%"
                @search="searchDrivers"
                :filterOption="false"
                :initialValue="undefined"
              >
                <a-select-option :value="0">
                  All Drivers
                </a-select-option>
                <template>
                  <a-select-option v-for="driver in drivers" :value="driver.id" :key="driver.id">
                    {{driver.first_name + ' ' + driver.last_name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Select vehicle type">
              <a-select placeholder="Select vehicle type"
                v-decorator="['vehicle_type', { rules: [{ required: false, message: 'Please select a vehicle type!' }] }]">
                <a-select-option v-for="(vehicleType, index) in vehicleTypes" :key="index"
                  :value="vehicleType.value">{{ vehicleType.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

            <a-form-item label="Select Route(s)" class="mb-2">
              <a-select
                show-search
                mode="multiple"
                size="default"
                v-decorator="['route_id',{
                  rules: [{
                    required: true,
                    message: 'Please select route(s)',
                  }],
                }]"
                placeholder="Search route."
                optionFilterProp="children"
                style="width: 100%"
                @search="searchRoutes"
                :filterOption="true"
                :initialValue="undefined"
              >
                <template>
                  <a-select-option v-for="route in routes" :value="route.id" :key="route.id">
                    {{ 'Route No. ' + route.route_no + ' - ' + route.route_name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>

          <a-form-item label="Add student(s)" class="mb-2">
            <a-select
              show-search
              mode="multiple"
              size="default"
              v-decorator="['student_id',{
                rules: [{
                  required: true,
                  message: 'Please select student(s)',
                }],
              }]"
              placeholder="Search students."
              optionFilterProp="children"
              style="width: 100%"
              @search="searchStudents"
              :filterOption="false"
              :initialValue="undefined"
            >
              <template>
                <a-select-option v-for="student in students" :value="student.id" :key="student.id">
                  {{student.first_name + ' ' + student.last_name + ' (' + student.student_code + ')' }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item label="Remark">
          <a-textarea placeholder="Remark" :autosize="{ minRows: 2 }"
            v-decorator="['remark', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const vehicleTypes = [
  { value: 'Van', name: 'Van' },
  { value: 'Bus', name: 'Bus' },
  { value: 'Eco Van', name: 'Eco Van' },
]

export default {
  name: 'EditVehicle',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      vehicleTypes,
      drivers: [],
      routes: [],
      students: [],
      oldrecord: {},
      studentIds: [],
      routeIds: [],
    }
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
    // this.searchDrivers()
    // this.searchRoutes()
    // this.searchStudents()
  },
  watch: {
    formVisible: function (n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    showForm: function (record) {
      console.log('Record', record)
      this.visible = true
      // this.searchDrivers()
      this.oldrecord = record
      this.drivers = [record.driver] // convert object {record.driver} to array of object [{record.driver}]
      this.routeIds = []
      if (record.routes.length > 0) {
        for (let i = 0; i < record.routes.length; i++) {
          this.routeIds.push(record.routes[i].id)
        }
        // this.searchRoutes()
        this.routes = record.routes
      }
      this.studentIds = []
      if (record.students.length > 0) {
        for (let i = 0; i < record.students.length; i++) {
          this.studentIds.push(record.students[i].id)
        }
        // this.searchStudents()
        this.students = record.students
      }
      console.log(this.routeIds)
      setTimeout(() => {
        this.form.setFieldsValue({
          vehicle_no: record.vehicle_no,
          registration_no: record.registration_no,
          staff_id: record.staff_id,
          vehicle_type: record.vehicle_type,
          route_id: this.routeIds,
          student_id: this.studentIds,
          remark: record.remark,
        })
      }, 50)
    },
    searchDrivers: function(value) {
      this.$http.get('/api/transport/driver')
        .then(({ data }) => {
          this.drivers = data.data
          console.log('driver: ', this.drivers)
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchRoutes: function (value) {
      this.$http.get('/api/transport/route', {
        params: {
          limit: 10,
          search: value,
        },
      })
        .then(({ data }) => {
          this.routes = data.data
          console.log('routes: ', this.routes)
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchStudents: function (value) {
      this.$http.get('/api/transport/student', {
        params: {
          limit: 20,
          search: value,
          page: 1,
        },
      })
        .then(({ data }) => {
          this.students = data.data
          console.log('student: ', this.students)
        })
        .catch(error => {
          console.log(error)
        })
    },
    savedata: function () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // clearform(this.form)
          // TODO - check if any changes in routes and students. If no changes, then do not update routes and students
          // Do not pass any values for routes and students

          this.$confirm({
            title: `Are you sure you want to edit the vehicle with vehicle no. ${values.vehicle_no}?`,
            content: `Click on the OK button to edit the vehicle!`,
            onOk: () => {
              this.$http.patch(`/api/transport/vehicle/${this.oldrecord.id}`, {
                vehicle_no: values.vehicle_no,
                registration_no: values.registration_no,
                staff_id: values.staff_id,
                vehicle_type: values.vehicle_type,
                remark: values.remark,
                routeIds: values.route_id, // route_id is an array with multiple ids or single id
                studentIds: values.student_id, // student_id is an array with multiple ids or single id
              })
                .then((resp) => {
                  if (resp.status === 200 || resp.status === 201) {
                    this.loading = false
                    this.visible = false
                    this.$emit('onEdited')
                    this.$notification['success']({
                      message: resp.data.message.success,
                      description: `Vehicle with vehicle no. ${values.vehicle_no} updated successfully!`,
                    })
                    console.log('response: ', resp)
                    // this.showInwardTransactionModal(resp.data.data)
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>

<style></style>
